<template>
	<v-row align="center" justify="center">
		<v-col cols="12" sm="10" md="8">
			<h1>Page Not Found</h1>
		</v-col>
	</v-row>
</template>

<script>
export default {
	name: 'PageNotFound',
	components: {},
	data: () => ({}),
	methods: {},
};
</script>
